<template>
  <div class="menu-container">
    <el-menu class="el-menu-vertical" :collapse="isCollapse" :default-active="$route.path"
      background-color="rgb(48, 65, 86)" text-color="#fff" active-text-color="#ffd04b" :collapse-transition="false">
      <div class="logo">
        <transition name="el-fade-in">
          <div v-if="isCollapse && showLogo" class="logo1">
            <img :src="`${env.webUrl}images/logo.png`" style="width: 100%;" />
          </div>
        </transition>
        <transition name="el-fade-in">
          <div v-if="!isCollapse && showLogo" class="logo2">
            <img :src="`${env.webUrl}images/logo.png`" style="width: 40px;height: 15px;" />
            <text>七星臻选</text>
          </div>
        </transition>
      </div>
      <sidebar-item :routes="routers"></sidebar-item>
    </el-menu>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useAppStore } from '@/store/app'
import { useRouteStore } from '@/store/route'

const useApp = useAppStore()
const useRoute = useRouteStore()
const isCollapse = computed(() => {
  return useApp.isCollapse
})
const showLogo = computed(() => {
  return useApp.showLogo
})
const routers = computed(() => {
  return useRoute.addRouters
})
</script>

<script>
const apiUrl = import.meta.env.VITE_APP_BASE_API // 要保证取到
import sidebarItem from './sidebarItem.vue'

export default {
  components: {
    sidebarItem,
  },
  data() {
    return {
      companyName: localStorage.getItem('X-tenantName'),
      formVisible: false,
      logoImage: '',
      logoForm: {
        logoImage: '',
      },
    }
  },
  computed: {
    // ...mapState({
    //   routers: state => state.route.routers,
    //   isCollapse: state => state.app.isCollapse,
    //   showLogo: state => state.app.showLogo,
    // })
  },
  methods: {
    handleChangeLogo: function () {
      this.formVisible = true
      this.logoForm.logoImage = ''
    },
    handleSubmit: function () {
      if (this.logoForm.logoImage != '') {
        changeLogo({ logo: this.logoForm.logoImage }).then((response) => {
          if (response) {
            this.logoImage = apiUrl + this.logoForm.logoImage
            this.formVisible = false
            localStorage.setItem('X-companyLogo', this.logoForm.logoImage)
          }
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.menu-container {
  height: 100%;
}

a {
  text-decoration: none !important;
  text-decoration: underline;
}

:deep(.el-menu) {
  border: 0;
  height: 100%;
  user-select: none;

  // background: var(menu-bg);
  .logo {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 50px;

    div {
      font-size: 18px;
      letter-spacing: 2px;
      color: white;
    }

    .logo1 {
      margin-left: 0px;
      width: 40px;
      height: 30px;
    }

    .logo2 {
      margin-left: -20px;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;

      img {
        margin-right: 10px;
      }
    }
  }
}

:deep(.horizontal-collapse-transition) {
  transition: 0.1s width ease-in-out, 0.1s padding-left ease-in-out, 0.1s padding-right ease-in-out;
}

:deep(.el-menu-vertical):not(.el-menu--collapse) {
  width: 220px;
}

.el-menu--vertical {
  // margin-top: 5px !important;
}

::v-deep .el-menu-item,
.el-sub-menu__title {
  height: 45px !important;
  line-height: 45px !important;
}

::v-deep .el-sub-menu__title {
  height: 45px !important;
  line-height: 45px !important;
}


.el-submenu__title:hover {
  background-color: rgba(255, 255, 255, 0.1) !important;
}

.el-menu-item:focus,
.el-menu-item:hover {
  outline: 0;
  background-color: rgba(255, 255, 255, 0.1) !important;
}
</style>
